import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  search: {
    width: theme.spacing(60),

    '& .MuiInput-root.MuiInput-formControl': {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
  },
});

export default styles;
